"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ setSettlementRequestData, setValue, }) {
    setSettlementRequestData(prev => (Object.assign(Object.assign({}, prev), { company_number: null, company_name: null, company_post_code: null, channel_company_seller_publish_agree: false })));
    setValue('tax_type', 0);
}
exports.default = default_1;
